package com.patronat.top.features.auth.presentation.ui

import androidx.compose.foundation.layout.*
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.patronat.top.dto.AuthMethod
import com.patronat.top.features.auth.presentation.AuthEvent
import com.patronat.top.features.auth.presentation.AuthViewModel
import com.patronat.top.ui.atoms.AppButton
import com.patronat.top.ui.atoms.AppRadioButton
import com.patronat.top.ui.atoms.ButtonType
import com.patronat.top.ui.atoms.inputs.InputState
import com.patronat.top.ui.molecules.branding.AppLogo
import com.patronat.top.ui.molecules.inputs.AppInput
import com.patronat.top.ui.molecules.inputs.AppInputMode
import com.patronat.top.ui.theme.*
import org.jetbrains.compose.resources.stringResource
import top.features.auth.generated.resources.Res
import top.features.auth.generated.resources.*

@Composable
fun LoginContent(viewModel: AuthViewModel) {
    val state by viewModel.viewState.collectAsState()
    val isPhoneLogin = state.loginMethod == AuthMethod.PHONE

    Column(
        modifier = Modifier
            .fillMaxSize()
            .padding(bottom = 20.dp),
        horizontalAlignment = Alignment.Start,
        verticalArrangement = Arrangement.Center
    ) {

        AppLogo()

        Spacer(modifier = Modifier.height(24.dp))

        // --- 2. Заголовки ---
        Text(
            text = stringResource(Res.string.login_title),
            style = LabelLarge.copy(fontSize = 24.sp),
        )

        Spacer(modifier = Modifier.height(8.dp))

        Text(
            text = stringResource(Res.string.login_welcome),
            style = BodyMedium
        )

        Spacer(modifier = Modifier.height(32.dp))

        Text(
            text = stringResource(Res.string.login_choose_method),
            style = LabelLarge.copy(fontSize = 16.sp),
            modifier = Modifier.padding(bottom = 12.dp)
        )

        Row(
            modifier = Modifier.fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically
        ) {
            AppRadioButton(
                selected = isPhoneLogin,
                onClick = { viewModel.onEvent(AuthEvent.OnLoginMethodSelected(AuthMethod.PHONE)) },
                label = stringResource(Res.string.method_phone) // "Номер телефону"
            )

            Spacer(modifier = Modifier.width(24.dp))

            AppRadioButton(
                selected = !isPhoneLogin,
                onClick = { viewModel.onEvent(AuthEvent.OnLoginMethodSelected(AuthMethod.EMAIL)) },
                label = stringResource(Res.string.method_email) // "Електронна пошта"
            )
        }

        Spacer(modifier = Modifier.height(24.dp))

        // --- 4. Поле вводу ---
        if (isPhoneLogin) {
            AppInput(
                value = state.phone,
                onValueChange = { viewModel.onEvent(AuthEvent.OnAuthDataChanged(phone = it)) },
                label = stringResource(Res.string.label_phone),
                placeholder = "+38 (050) 000 0000",
                hint = state.phoneError?.asString(),
                forceState = if (state.phoneError != null) InputState.Error else null,
                inputMode = AppInputMode.Phone,
                keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Phone)
            )
        } else {
            AppInput(
                value = state.email,
                onValueChange = {
                    viewModel.onEvent(AuthEvent.OnAuthDataChanged(email = it))
                                },
                label = stringResource(Res.string.label_email),
                placeholder = "example@mail.com",
                leadingIcon = AppIcons.Email,
                hint = state.emailError?.asString(),
                forceState = if (state.emailError != null) InputState.Error else null,
                keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Email)
            )
        }

        // --- АЛЕРТ ПРИБРАНО (він тепер глобальний) ---

        Spacer(modifier = Modifier.height(24.dp))

        // --- 5. Кнопка Входу ---
        AppButton(
            text = stringResource(Res.string.action_login), // "Увійти"
            onClick = { viewModel.onEvent(AuthEvent.OnSubmitLogin) },
            type = ButtonType.BrownFilled,
            isLoading = state.isLoading,
            modifier = Modifier
                .fillMaxWidth()
                .height(48.dp)
        )
    }
}
